import { useSelector } from 'react-redux';

import { getAuthFlow } from '../../../store/slices/authSlice';
import AddEmailStep from './AddEmailStep';
import EntryStep from './EntryStep';
import ForgotPasswordStep from './ForgotPasswordStep';
import ResetPasswordStep from './ResetPasswordStep';
import SetPasswordStep from './SetPasswordStep';
import SignInStep from './SignInStep';
import VerifyAddedEmailStep from './VerifyAddedEmailStep';
import VerifyCodeStep from './VerifyCodeStep';

// HORO-10509: AuthModal still treats this as a single "step 1" component
// (stepsConfig[0] in AuthModal.js) — internally it now routes between the
// OAuth/email-entry screen and the rest of the email/password sub-flow
// (signup verification, signin, forgot/reset password) based on
// authSlice's `authFlow`, which stays independent of registerStepCount
// (step 1 vs step 2 birth-details) throughout.
const FLOW_COMPONENTS = {
    entry: EntryStep,
    'set-password': SetPasswordStep,
    'verify-email': VerifyCodeStep,
    'sign-in': SignInStep,
    'forgot-password': ForgotPasswordStep,
    'reset-password': ResetPasswordStep,
    'add-email': AddEmailStep,
    'verify-added-email': VerifyAddedEmailStep
};

const FirstAuthStep = () => {
    const authFlow = useSelector(getAuthFlow);
    const Step = FLOW_COMPONENTS[authFlow] || EntryStep;

    return <Step />;
};

export default FirstAuthStep;
